import CsuDiagnosisPhase from '@/components/AttendanceForm/csu/phase/CsuDiagnosisPhase'
import CsuDiseaseActivityPhase from '@/components/AttendanceForm/csu/phase/CsuDiseaseActivityPhase'
import CsuHypothesisPhase from '@/components/AttendanceForm/csu/phase/CsuHypothesisPhase'
import CsuReportPhase from '@/components/AttendanceForm/csu/phase/CsuReportPhase'
import CsuStepsPhase from '@/components/AttendanceForm/csu/phase/CsuStepsPhase'
import CsuExamsPhase from '@/components/AttendanceForm/csu/phase/CsuExamsPhase'
import CsuSummary from '@/components/AttendanceForm/csu/summary/CsuSummary'
import CsuFamilyHistoryPhase from '@/components/AttendanceForm/csu/phase/CsuFamilyHistoryPhase.vue'
import ImagePhase from '@/components/AttendanceForm/general/phase/ImagePhase.vue'
import LmePhase from '@/components/AttendanceForm/general/phase/LmePhase.vue'
import MedicinesPhase from '@/components/AttendanceForm/general/phase/MedicinesPhase.vue'
import PersonalHistoryPhase from '@/components/AttendanceForm/general/phase/PersonalHistoryPhase.vue'
import PsychiatricScreeningPhase from '@/components/AttendanceForm/general/phase/PsychiatricScreeningPhase.vue'
import TreatmentPhase from '@/components/AttendanceForm/general/phase/TreatmentPhase'
import { AttendanceConfig } from './AttendanceConfig'
import {
  generateFamilyHistoryOverview,
  generatePersonalHistoryOverview,
  generatePsychiatricScreenOverview,
} from './defaultConfig'

export default new AttendanceConfig()
  .addStep('Anamnese')
  .addPhase('diagnostico', 'Diagnóstico', CsuDiagnosisPhase)
  .addPhase('tratamentos_previos', 'Tratamentos Prévios', TreatmentPhase)
  .addPhase('investigacao_pessoal', 'Investigação pessoal', PersonalHistoryPhase, generatePersonalHistoryOverview)
  .addPhase('investigacao_familiar', 'Investigação familiar', CsuFamilyHistoryPhase, generateFamilyHistoryOverview)
  .addPhase(
    'triagem_psiquiatrica',
    'Triagem psiquiátrica',
    PsychiatricScreeningPhase,
    generatePsychiatricScreenOverview,
  )
  .addStep('Complementar')
  .addPhase('atividade_doenca', 'Atividade da Doença', CsuDiseaseActivityPhase)
  .addPhase('imagens', 'Imagens', ImagePhase)
  .addPhase('exames', 'Exames', CsuExamsPhase)
  .addStep('Resultados')
  .addPhase('hipotese', 'Hipótese', CsuHypothesisPhase)
  .addPhase('steps', 'Steps', CsuStepsPhase)
  .addPhase('medicamentos', 'Medicamentos', MedicinesPhase)
  .addPhase('relatorio_medico', 'Relatório médico', CsuReportPhase)
  .setSummaryComponent(CsuSummary)

function generateNotesOverview(data, attendance) {
  if (data?.notes) {
    return data.notes.split(/\n/)
  }

  return []
}

function generateSymptomsOverview(data, attendance) {
  if (!data) {
    return []
  }

  const paragraphs = []

  const checkedSymptoms = Object.keys(data.symptoms || {})
    .filter((key) => data.symptoms[key].value)
    .map((key) => ({ ...data.symptoms[key], key }))

  if (checkedSymptoms.length > 0) {
    const texts = checkedSymptoms.map((symptom) => {
      const symptomOption = SYMPTOM_OPTIONS.find((item) => item.key === symptom.key)
      const symptomName = symptomOption.name
      const period = isNaN(parseInt(symptom.period?.length))
        ? 'Sim'
        : symptom.period.length + (symptom.period.type === 'MES' ? ' mes(es)' : ' ano(s)')
      const suboptions = (symptomOption.options || [])
        .filter((suboption) => symptom.options.includes(suboption.key))
        .map((suboption) => suboption.name)
        .join(', ')

      let text = `${symptomName}: ${period}`
      if (suboptions) {
        text += ` (${suboptions})`
      }
      return `${text}.`
    })

    paragraphs.push(...texts)
  }

  paragraphs.push(...generateNotesOverview(data, attendance))

  return paragraphs
}

function generateMedicineHistoryOverview(data, attendance) {
  if (!data) {
    return []
  }

  const paragraphs = []

  if (data.profile['contraindicacao_aines']?.value) {
    paragraphs.push(`Paciente tem intolerância ou contraindicação a AINES.`)
  }

  const chosenMedicines = Object.keys(data.medicines || {})
    .map((key) => data.medicines[key])
    .sort(util.objectSorter((item) => item.medicine.category.name.toLowerCase() + item.medicine.name.toLowerCase()))

  for (const item of chosenMedicines) {
    if (paragraphs.length > 0) {
      paragraphs.push('')
    }

    const medicine = item.medicine
    const periods = item.periods || []

    paragraphs.push(`${medicine.name} (${medicine.category.name})`)
    const periodTexts = periods.map((period) => {
      let recurrence = 'por semana'
      if (period.period === 'DIAS') {
        recurrence = 'por dia'
      } else if (period.period === 'CADA_N_SEMANAS') {
        recurrence = `a cada ${period.length} `
        recurrence += period.length > 1 ? 'semanas' : 'semana'
      }
      let string =
        `- ` +
        (period.dosage ? `${period.dosage}mg ${recurrence}, ` : '') +
        `de ${util.toFormattedDate(period.start)} até ${util.toFormattedDate(period.end) || 'atualmente'}.`

      if (period.stopReason) {
        string += ` Motivo da parada: ${period.stopReason.name ?? period.stopReason ?? 'não informado'}.`
      }

      return string
    })
    paragraphs.push(...periodTexts)
  }

  paragraphs.push(...generateNotesOverview(data, attendance))

  return paragraphs
}
